import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileListControlView {

    constructor() {}

    afterRender(control) {
        let element = mobileAdjustment.adjustMobileControl(control);
        element.css("height", "auto");
        
        let select = element.find("div:first");
        select.css({"width":"100%", "height" : "22px", "text-align": "left", "overflow": "auto"});     
    }
}

const mobileListControlView = new MobileListControlView();
export default mobileListControlView;